import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { creditsApi } from '../lib/api';

const CreditsContext = createContext(null);

export const CreditsProvider = ({ children }) => {
  const [credits, setCredits] = useState({ balance: 0, history: [], costs: {} });
  const [loading, setLoading] = useState(true);

  const fetchCredits = useCallback(async () => {
    try {
      const response = await creditsApi.get();
      setCredits(response.data);
    } catch (error) {
      console.error('Error fetching credits:', error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchCredits();
  }, [fetchCredits]);

  const refreshCredits = useCallback(() => {
    fetchCredits();
  }, [fetchCredits]);

  return (
    <CreditsContext.Provider value={{ credits, loading, refreshCredits }}>
      {children}
    </CreditsContext.Provider>
  );
};

export const useCredits = () => {
  const context = useContext(CreditsContext);
  if (!context) {
    throw new Error('useCredits must be used within a CreditsProvider');
  }
  return context;
};

export default CreditsContext;
